import { inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ToastService, ToastVariant } from '@performance/ui'
import { signalStore, withMethods } from '@ngrx/signals'
import { firstValueFrom } from 'rxjs'
import { Toast } from '@core/models/toast.models'

export const ToastStore = signalStore(
  { providedIn: 'root' },
  withMethods(() => {
    const translate = inject(TranslateService)
    const uiToast = inject(ToastService)

    return {
      showToast(toast: Toast): void {
        const toTranslate = (text?: string) =>
          text ? firstValueFrom(translate.get(text)) : Promise.resolve(undefined)
        void Promise.all([toTranslate(toast.title), toTranslate(toast.body)]).then(
          ([title, body]) =>
            uiToast.show({
              title,
              body,
              variant: (toast.variant || 'success') as ToastVariant,
            }),
        )
      },
    }
  }),
)
